import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDateField, DBDropDown, DBTextField, DBCheckBox, CopyButton, CancelButton } from '_components';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';
import { getDateMMDDYYYY } from '_helpers';

class PatientCareCenterNoteGoalsGoalShortTermGoalDetail extends React.Component {

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.shortGoal.SGNO, 'SGGPNO', this.props.shortGoal.SGGPNOPREV);
    }
    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.shortGoal.SGNO, 'SGACTIVE', false);
    }

    render() {

        return (
            <PatientCareCenterNoteNavAnchor id={'sgno_' + this.props.shortGoal.SGNO} >
                <div className={styles.stg_detail_wrapper}>
                    <div className={styles.stg_detail_row}>
                        {(this.props.isPrevGoal && (this.props.isSpeech || this.props.isPeds)) &&
                            <span className={styles.stg_checkbox}>
                                <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                            </span>
                        }
                        <div className={styles.stg_checkbox}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTSHORTGOALS'
                                entityKeyColumn='SGNO'
                                entityKeyValue={this.props.shortGoal.SGNO}
                                field='SGACTIVE'
                                className={styles.checkbox}
                                label={this.props.shortGoal.SGNAME}
                                disabled={this.props.disableEdit}
                            />
                        </div>
                        <div className={styles.stg_desc}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTSHORTGOALS'
                                entityKeyColumn='SGNO'
                                entityKeyValue={this.props.shortGoal.SGNO}
                                field='SGDESC'
                                className={this.props.reqDesc ? styles.text_field_req : styles.text_field}
                                disabled={this.props.disableEdit}
                                placeholder='Describe or quantify goal'
                            />
                        </div>
                        <div className={styles.stg_date}>
                            <span className={styles.date_field}>
                                <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTSHORTGOALS'
                                    entityKeyColumn='SGNO'
                                    entityKeyValue={this.props.shortGoal.SGNO}
                                    maxDate={new Date().setFullYear(new Date().getFullYear() + 1)}
                                    field='SGDATE'
                                    disabled={this.props.noteType === 2}
                                    customMsg='The goal date cannot be in the past.'
                                    minDate={getDateMMDDYYYY(new Date())}
                                    defaultdate={this.props.days}
                                    required={this.props.reqDate}
                                />
                            </span>
                        </div>
                        {this.props.noteType !== 1 &&
                            <>
                                <span className={styles.goal_detail_prog_dropdown_stg}>
                                    <DBDropDown
                                        className={this.props.reqProgress ? styles.goal_level_dropdown_req : styles.goal_level_dropdown}
                                        noteId={this.props.noteId}
                                        entity='PTSHORTGOALS'
                                        entityKeyColumn='SGNO'
                                        entityKeyValue={this.props.shortGoal.SGNO}
                                        field='SGGPNO'
                                        masterEntity='PTMASTERGOALPROGRESS'
                                        masterEntityKeyColumn='GPNO'
                                        masterEntitySort='GPORDER'
                                        masterEntityDisplay='GPNAME'
                                    />
                                </span>
                                {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                    <div className={styles.goal_detail_copy_col}>
                                        <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                    </div>
                                }
                            </>
                        }
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let shortGoal = state.entities.notes.PTSHORTGOALS[ownprops.id];
    let days = ownprops.days;

    let sgno = ownprops.SGNO;
    let disableEdit = false;
    let defaultDate = ownprops.days ?? 0;
    if (noteType !== 1 && shortGoal.SGSGNO) {
        disableEdit = true;
    }

    let reqDesc = false;
    let reqDate = false;
    let reqProgress = false;

    if (shortGoal.SGACTIVE && !shortGoal.SGDESC) {
        reqDesc = true;
    }
    if (shortGoal.SGACTIVE && !shortGoal.SGDATE) {
        reqDate = true;
    }
    if (shortGoal.SGACTIVE && !shortGoal.SGGPNO) {
        reqProgress = true;
    }

    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled ? true : false;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled ? true : false;

    let isPrevGoal = state.entities.notes.PTSHORTGOALS[ownprops.id].SGSGNO ? true : false;

    return {
        noteId,
        noteType,
        pk,
        shortGoal,
        days,
        sgno,
        disableEdit,
        defaultDate,
        reqDesc,
        reqDate,
        reqProgress,
        isSpeech,
        isPeds,
        isPrevGoal
    };
}

const connectedPatientCareCenterNoteGoalsGoalShortTermGoalDetail = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalShortTermGoalDetail);
export { connectedPatientCareCenterNoteGoalsGoalShortTermGoalDetail as PatientCareCenterNoteGoalsGoalShortTermGoalDetail };

